module.exports = __webpack_public_path__ + "img/heart.23391c88.png";